import { Injectable, Inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {StorageService} from '../../services/storage.service';
import {ChallengeStatusType} from '../../models/answers/answers-models';
@Injectable({
  providedIn: 'root'
})
export class InvoicesService {

  constructor(
    @Inject('InvoicesFirestore') private invoicesFire: AngularFirestore,
    private storageService: StorageService,
  ) { }

  updateInvoicesStatus(id: string, newStatus: ChallengeStatusType,dataConfirmation?) {
    const account = this.storageService.get('account');
    if (!account) {
      throw new Error('No se encuentran los datos del usuario actual.');
    }
    const db = this.invoicesFire.firestore;
    const docRef = db.doc(`InvoicesAnswers/${id}`);
    const products = dataConfirmation.products;
    const data =  {
      status: newStatus,
      invoiceConfirmation: {
        invoiceIdConfirmation: dataConfirmation.id,
        dateConfirmation: dataConfirmation.dateConfirmation,
        totalConfirmation: dataConfirmation.totalConfirmation,
      },
      products,
      rejectionCause: dataConfirmation.rejectionCause,
      comment: dataConfirmation.comment,
      updatedBy: {
        id: account.id,
        appId: account.app_id,
        username: account.username,
      },
      checker: {
        id: account.id,
        username: account.username,
        designateBy: {
          id: null,
          username: null,
        },
        designateAt: null,
      },
      updatedAt: new Date(),
      statusHistory : dataConfirmation.statusHistory ? dataConfirmation.statusHistory : {}
    };
    data.statusHistory[newStatus] = new Date();
    if(!dataConfirmation.products){
      delete data.products;
    }
    return docRef.update(data);
  }

  fieldTextValue(val: any) {
    const txtVal = `${val}`;
    const maxlen = 20;
    const slicedVal = txtVal.slice(0, maxlen) + (txtVal.length > maxlen ? '...' : '');
    return slicedVal;
  }

  async verifyId( newId){
    const db = this.invoicesFire.firestore;
    const docRef = db.collection('InvoicesAnswers')
      .where('invoiceConfirmation.invoiceIdConfirmation', '==', newId)
      .get();
    return await docRef;

  }
}
